import React from "react"
import PropTypes from "prop-types"
import logo from '../images/logo.png';

class HelloWorld extends React.Component {
  render () {
    return (

      <div style={{
              position: 'absolute', left: '50%', top: '50%',
              transform: 'translate(-50%, -50%)'
            }}
      >
        <img src={logo} width={300} height={300} style={{ alignSelf: 'center' }} />
      </div>
    );
  }
}

HelloWorld.propTypes = {
  greeting: PropTypes.string
};
export default HelloWorld

const styles = {
  container: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }
};
